export default __webpack_public_path__ + "static/media/uploader-trivia-4.769ce489.png";